export default "__VITE_ASSET__CjA56MMx__"